// Packages
import PropTypes from 'prop-types';
import { useState } from 'react';

// Components
import ListItem from 'modules/PurchaseOrderItems/components/ListItem';
import EditIcon from 'components/BTDUI/icons/EditIcon';

// Other
import './styles.css';
import PurchaseOrderEditScreen from 'modules/PurchaseOrders/screens/Edit';

const PurchaseOrderItemList = ({ discount, delivery, isLoading, items, purchaseOrderId, subtotal, onChange, total }) => {

	const [formActive, setFormActive] = useState(false);

	// Loading State
	if ( isLoading )
	{
		return (
			<div className='PurchaseOrderItemList'>
				<ListItem isLoading={true}/>
			</div>
		)
	}


	// Empty State
	if ( items.length === 0 )
	{
		return (
			<h3 className='opacity italic'>No purchase order items to show here</h3>
		)
	}


	// Data State
	return (
		<>
		<div className='PurchaseOrderItemList'>

			<div className='PurchaseOrderItemList__tr PurchaseOrderItemList__header tr'>
				<div className='th left'>Qty</div>
				<div className='th left'>Description</div>
				<div className='th right'>Unit Price</div>
				<div className='th right'>Total Price</div>
			</div>

			{items.map((item, index) => {

				return (
					<ListItem 
						{...item} 
						isLoading={false}
						key={index}
						onChange={() => {onChange()}}
						purchaseOrderId={purchaseOrderId}
					/>
				)
				
			})}

			<div className='PurchaseOrderItemList__border'/>

			<div className='PurchaseOrderItemList__tr'>
				<span className='td'></span>
				<span className='td'></span>
				<span className='th right'>Subtotal</span>
				<span className='th right'>£ {subtotal.toFixed(2)}</span>
			</div>
			<div className='PurchaseOrderItemList__tr'>
				<span className='td'></span>
				<span className='td'></span>
				<span className='td right'>Discount</span>
				<span className='td right'>£ {discount ? discount.toFixed(2) : '0.00'}</span>
				<span className='td'>
					<EditIcon
						height='16px' 
						onClick={() => {setFormActive(true)}}
						style={{cursor: 'pointer'}}
						width='16px'
					/>
				</span>
			</div>
			<div className='PurchaseOrderItemList__tr'>
				<span className='td'></span>
				<span className='td'></span>
				<span className='td right'>Delivery</span>
				<span className='td right'>£ {delivery ? delivery.toFixed(2) : '0.00'}</span>
				<span className='td'>
					<EditIcon
						height='16px' 
						onClick={() => {setFormActive(true)}}
						style={{cursor: 'pointer'}}
						width='16px'
					/>
				</span>
			</div>
			<div className='PurchaseOrderItemList__tr'>
				<span className='td'></span>
				<span className='td'></span>
				<span className='th right'>Total</span>
				<span className='th right'>£ {total.toFixed(2)}</span>
			</div>

		</div>


		{formActive &&
			<PurchaseOrderEditScreen
				itemId={purchaseOrderId}
				onClose={() => {
					setFormActive(false);
				}} 
				onSubmit={() => {
					onChange();
					setFormActive(false);
				}} 
			/>
		}
		</>
	)
}

PurchaseOrderItemList.propTypes = {
	isLoading: PropTypes.bool,
	items: PropTypes.array,
	onChange: PropTypes.func,
	purchaseOrderId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

PurchaseOrderItemList.defaultProps = {
	isLoading: false,
	items: [],
	onChange: () => {'onChange is not set!'},
	purchaseOrderId: null,
}

export default PurchaseOrderItemList;